/**
 * Feature access types - gates features by product tier and user group.
 * Add new feature keys here as you add capabilities (e.g. blog_publishing).
 */

/** Features that can be gated by tier / group */
export type FeatureKey =
  | "ugc_video"
  | "blog_publishing"
  | "visibility_manager"
  | "reddit_feed"
  | "deep_research";

/** Self-service subscription product names (matched against subscription_product_name). */
export type SubscriptionTier = string;

/**
 * Which self-service plans unlock which features. Matched (case-insensitive,
 * substring) against the user's subscription_product_name. Internal/SuperAdmin
 * (incl. managed-service team) bypass this entirely.
 * Self-service plans: "Sagelyn Starter" ($14.99), "Sagelyn Pro" ($48.99).
 * Video + blog are Sagelyn Pro only.
 */
export const FEATURE_TIERS: Record<FeatureKey, SubscriptionTier[]> = {
  ugc_video: ["sagelyn pro"],
  blog_publishing: ["sagelyn pro"],
  visibility_manager: ["sagelyn pro"],
  // Always intended to be Pro, but shipped ungated — Starter accounts could
  // use both until this was closed on 2026-08-25.
  reddit_feed: ["sagelyn pro"],
  deep_research: ["sagelyn pro"],
};

/** Human-readable feature names for upgrade modal copy */
export const FEATURE_LABELS: Record<FeatureKey, string> = {
  ugc_video: "Video Creator",
  blog_publishing: "Blog publishing",
  visibility_manager: "AI Visibility Manager",
  reddit_feed: "Reddit Feed",
  deep_research: "Deep Research",
};
